import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Intro } from './components/Intro';
import { WhatWeDeliver } from './components/WhatWeDeliver';
import { PlatformCapabilities } from './components/PlatformCapabilities';
import { Process } from './components/Process';
import { WhoFor } from './components/WhoFor';
import { CaseStudies } from './components/CaseStudies';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white selection:bg-brand-green/30 selection:text-brand-navy" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Intro data-id="element-4" />
        <WhatWeDeliver data-id="element-5" />
        <PlatformCapabilities data-id="element-6" />
        <Process data-id="element-7" />
        <WhoFor data-id="element-8" />
        <CaseStudies data-id="element-9" />
        <CTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}